import { useActions } from '@root/core/hooks/useActions';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { inquiryInboundInfo } from '@root/state/reducers/Settlement/settlementReducer';
import { Button, Card, Col, Divider, Row, Spin } from 'antd';
import { saveAs } from 'file-saver';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CustomerIDInforComponent from '../../components/customerIDInfor';
import FromToInforComponent from '../../components/FromToInfor';
import InqueryHistory from '../../components/InqueryHistory';
interface ParamType {
  id: string;
}
const Breadcrumb = [
  {
    tittle: 'Settlement',
    url: ''
  },
  {
    tittle: 'Billing Inquiry',
    url: '/admin/billingInquiry'
  },
  {
    tittle: 'Billing Inquiry (Detail)',
    url: ''
  }
];

function BillingInquiryDetailPage() {
  const { id } = useParams<ParamType>();

  const { getBillingInquiryDetail } = useActions();

  useEffect(() => {
    getBillingInquiryDetail(id);
  }, []);

  const { detail, loading } = useTypedSelector(
    (state) => state.billingInquiryDetailReducer
  );

  // info Ids
  const infoIds = {
    receiptId: detail?.receiptId,
    customerId: detail?.seller.email,
    warehouseId: detail?.warehouse.email
  };

  const fromToInfo = {
    seller: detail?.seller,
    warehouse: detail?.warehouse,
    admin: detail?.admin
  };

  // Inquiry history
  const inquiryHistory: inquiryInboundInfo = {
    numberDelivered: detail?.numberDelivered ? detail?.numberDelivered : 0,
    numberDisposal: detail?.numberDisposal ? detail?.numberDisposal : 0,
    numberProductTypes: detail?.numberProductTypes
      ? detail?.numberProductTypes
      : 0,
    numberReturn: detail?.numberReturn ? detail?.numberReturn : 0,
    orderCounts: detail?.orderCounts ? detail?.orderCounts : 0,
    warehouse: detail?.warehouse
  };

  // detail dates
  const dates = {
    startDate: detail?.periodStart ? detail?.periodStart : 0,
    endDate: detail?.periodEnd ? detail?.periodEnd : 0
  };

  const getDate = (startDate?: string, endDate?: string) => {};

  const download = () => {
    saveAs(
      detail?.billingInquiryFile?.url,
      detail?.billingInquiryFile?.fileName
    );
  };

  return (
    <Spin spinning={loading}>
      <div>
        <BreadcrumbList listBreadcrumb={Breadcrumb} />
        <div className="billingDetail">
          <Row gutter={40} style={{ marginBottom: '35px' }}>
            <Col span={10}>
              <Card style={{ height: '100%' }}>
                <CustomerIDInforComponent infoIds={infoIds} />
              </Card>
            </Col>
            <Col span={14}>
              <Card>
                <FromToInforComponent fromToInfo={fromToInfo} />
              </Card>
            </Col>
          </Row>
          <Card>
            <div className="settlement-status">
              <div className={'settlement-status-content'}>
                {detail?.billingStatus}
              </div>
            </div>
            <InqueryHistory
              idCustomer={id}
              inquiryHistory={inquiryHistory}
              dates={dates}
              getDate={getDate}
            />
            <Row>
              <Col span={6}>
                <h2 style={{ marginBottom: '0', fontSize: '30px' }}>
                  Total Payment
                </h2>
              </Col>
              <Col span={14}>
                <Divider dashed style={{ borderWidth: '2px 0 0' }} />
              </Col>
              <Col span={6} align="right">
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '25px',
                    fontWeight: 'bolder'
                  }}
                >
                  US$ {detail?.billingAmount}
                </p>
              </Col>
            </Row>
            <Row style={{ margin: '20px 0' }}>
              <Col span={24} align="right">
                <Button className="download_inquery" onClick={download}>
                  Download Billing Inquiry
                </Button>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </Spin>
  );
}

export default BillingInquiryDetailPage;
